import React from "react";

// mui components
import { TextField } from "@mui/material";

// custom styles
import styles from "./index.module.scss";

const OutlinedTextarea = ({
	variant,
	label,
	name,
	placeholder,
	inputProps,
	multiline,
	rows,
	autoComplete,
	value,
	extraClass,
	fullWidth,
	handleChange,
	disabled
}) => {
	const customClass = `${styles.inputField} ${extraClass} ${
		fullWidth ? styles.fullWidth : ""
	}`;

	return (
		<TextField
			variant={variant}
			id={`${variant}-basic`}
			label={label}
			name={name}
			placeholder={placeholder}
			inputProps={inputProps}
			multiline={multiline}
			rows={rows}
			autoComplete={autoComplete}
			value={value}
			className={customClass}
			onChange={handleChange}
			disabled={disabled}
		/>
	);
};

export default OutlinedTextarea;
